import { render, staticRenderFns } from "./TaxAccountList.vue?vue&type=template&id=f8cbf796&"
import script from "./TaxAccountList.vue?vue&type=script&lang=js&"
export * from "./TaxAccountList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports